const $ = require('jquery');

window.$ = $;
window.jQuery = $;
global.$ = $;
global.jQuery = $;

require('./flipbook');
